import { Action } from "@ngrx/store";
import { JobResponseDTO } from "../models/jobResponseDTO";
import { JobRequestDTO } from "../models/jobRequestDTO";



export enum JobActionTypes {
    // Get all jobs
    GET_ALL_JOBS = "[Job] Get All Jobs",
    GET_ALL_JOBS_SUCCESS = "[Job] Get All Jobs Success",
    GET_ALL_JOBS_ERROR = "[Job] Get All Jobs Error",

    // Delete job
    DELETE_JOB = "[Job] Delete Job",
    DELETE_JOB_SUCCESS = "[Job] Delete Job Success",
    DELETE_JOB_ERROR = "[Job] Delete Job Error",

    // New job
    NEW_JOB = "[Job] New Job",
    NEW_JOB_SUCCESS = "[Job] New Job Success",
    NEW_JOB_ERROR = "[Job] New Job Error",

    // Save job
    SAVE_JOB = "[Job] Save Job",
    SAVE_JOB_SUCCESS = "[Job] Save Job Success",
    SAVE_JOB_ERROR = "[Job] Save Job Error",

    // Edit job
    EDIT_JOB = "[Job] Edit Job",
    EDIT_JOB_SUCCESS = "[Job] Edit Job Success",
    EDIT_JOB_ERROR = "[Job] Edit Job Error",

    // Update job
    UPDATE_JOB = "[Job] Update Job",
    UPDATE_JOB_SUCCESS = "[Job] Update Job Success",
    UPDATE_JOB_ERROR = "[Job] Update Job Error",
}

// Get All Jobs Actions
export class GetAllJobsAction implements Action {
    type: JobActionTypes = JobActionTypes.GET_ALL_JOBS;
    constructor(public payload: any) { }
}
export class GetAllJobsActionSuccess implements Action {
    type: JobActionTypes = JobActionTypes.GET_ALL_JOBS_SUCCESS;
    constructor(public payload: JobResponseDTO[]) { }
}
export class GetAllJobsActionError implements Action {
    type: JobActionTypes = JobActionTypes.GET_ALL_JOBS_ERROR;
    constructor(public payload: string) { }
}

// Delete Job Actions
export class DeleteJobAction implements Action {
    type: JobActionTypes = JobActionTypes.DELETE_JOB;
    constructor(public payload: JobRequestDTO) { }
}
export class DeleteJobActionSuccess implements Action {
    type: JobActionTypes = JobActionTypes.DELETE_JOB_SUCCESS;
    constructor(public payload: JobRequestDTO) { }
}
export class DeleteJobActionError implements Action {
    type: JobActionTypes = JobActionTypes.DELETE_JOB_ERROR;
    constructor(public payload: string) { }
}

// New Job Actions
export class NewJobAction implements Action {
    type: JobActionTypes = JobActionTypes.NEW_JOB;
    constructor(public payload: any) { }
}
export class NewJobActionSuccess implements Action {
    type: JobActionTypes = JobActionTypes.NEW_JOB_SUCCESS;
    constructor(public payload: any) { }
}
export class NewJobActionError implements Action {
    type: JobActionTypes = JobActionTypes.NEW_JOB_ERROR;
    constructor(public payload: string) { }
}

// Save Job Actions
export class SaveJobAction implements Action {
    type: JobActionTypes = JobActionTypes.SAVE_JOB;
    constructor(public payload: JobRequestDTO) { }
}
export class SaveJobActionSuccess implements Action {
    type: JobActionTypes = JobActionTypes.SAVE_JOB_SUCCESS;
    constructor(public payload: JobRequestDTO) { }
}
export class SaveJobActionError implements Action {
    type: JobActionTypes = JobActionTypes.SAVE_JOB_ERROR;
    constructor(public payload: string) { }
}

// Edit Job Actions
export class EditJobAction implements Action {
    type: JobActionTypes = JobActionTypes.EDIT_JOB;
    constructor(public payload: string) { }
}
export class EditJobActionSuccess implements Action {
    type: JobActionTypes = JobActionTypes.EDIT_JOB_SUCCESS;
    constructor(public payload: JobResponseDTO) { }
}
export class EditJobActionError implements Action {
    type: JobActionTypes = JobActionTypes.EDIT_JOB_ERROR;
    constructor(public payload: string) { }
}

// Update Job Actions
export class UpdateJobAction implements Action {
    type: JobActionTypes = JobActionTypes.UPDATE_JOB;
    constructor(public payload: { id: string, job: JobResponseDTO }) { }
}
export class UpdateJobActionSuccess implements Action {
    type: JobActionTypes = JobActionTypes.UPDATE_JOB_SUCCESS;
    constructor(public payload: JobResponseDTO) { }
}
export class UpdateJobActionError implements Action {
    type: JobActionTypes = JobActionTypes.UPDATE_JOB_ERROR;
    constructor(public payload: string) { }
}

export type JobActions =
    GetAllJobsAction | GetAllJobsActionSuccess | GetAllJobsActionError |
    DeleteJobAction | DeleteJobActionSuccess | DeleteJobActionError |
    NewJobAction | NewJobActionSuccess | NewJobActionError |
    SaveJobAction | SaveJobActionSuccess | SaveJobActionError |
    EditJobAction | EditJobActionSuccess | EditJobActionError |
    UpdateJobAction | UpdateJobActionSuccess | UpdateJobActionError;
